import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface ChannelListActionsHeaderProps
  extends HeaderContext<GatewayChannelWithChargePointInfoModel, unknown> {}

export const ChannelListActionsHeader =
  () // props: ChannelListActionsHeaderProps,
  : ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    // Nothong to do

    // RENDER ////////////////////////////////////////////////////////////////////

    return '';
  };
